import FilterModel from 'app/components/FilterModel';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { reportnewUserDataHeader } from 'app/constants/table-header-constants';
import useNewUserReport from './useNewUserReport';

const NewUserReport = () => {
  const {
    pageLoading,
    filteredData,
    paginationHandler,
    navigate,
    totalNumber,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    resetfilterModel,
    handleSubmit,
    handleFilterCancel,
    fetchReportData,
    isFiltering,
  } = useNewUserReport();

  return (
    <>
      <div className='cms-content__container'>
        <div className='cms-content__container billmanagement'>
          <PaginatedTable
            fulldata={filteredData}
            sectionObj={sectionObj}
            columns={reportnewUserDataHeader}
            data={filteredData}
            currentPage={currentPage}
            dataPerPage={dataPerPage}
            pageCountNumber={pageCount}
            totalNumber={totalNumber}
            pageLoading={pageLoading}
            navigate={navigate}
            isLoading={pageLoading}
            paginationHandler={paginationHandler}
            fetchData={fetchReportData}
            isFiltering={isFiltering}
            values={values}
          />
        </div>
        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            values={values}
            setValues={setValues}
            resetfilter={resetfilterModel}
          >
            <>
              {/* <div className='offcanvas-item'>
                <label>Mall Name</label>
                <input
                  type='text'
                  value={values?.mallName}
                  onChange={(e) =>
                    setValues({ ...values, mallName: e.target.value })
                  }
                />
              </div> */}
              <div className='offcanvas-item'>
                <label>Referrer Contact</label>
                <input
                  type='text'
                  value={values?.referrerContact}
                  onChange={(e) =>
                    setValues({ ...values, referrerContact: e.target.value })
                  }
                />
              </div>
              <label>Registeration Date ranges:</label>
              <div className='offcanvas-item'>
                <label> Start Date</label>
                <input
                  type='date'
                  value={values?.registrationDateStart}
                  max={values?.registrationDateEnd}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      registrationDateStart: e.target.value,
                    })
                  }
                />
              </div>

              <div className='offcanvas-item'>
                <label>End Date</label>
                <input
                  type='date'
                  value={values?.registrationDateEnd}
                  min={values?.registrationDateStart}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      registrationDateEnd: e.target.value,
                    })
                  }
                />
              </div>
            </>
          </FilterModel>
        )}
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default NewUserReport;
